const GenerateDescriptionErrors = {
  EMPTY: 'WorkflowDescriptionGenerationValidationError.EMPTY_FLOW',
  LARGE: 'WorkflowDescriptionGenerationValidationError.FLOW_TOO_LARGE'
};
export default GenerateDescriptionErrors;